import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  verifyToken: () => api.get('/auth/verify'),
  changePassword: (data) => api.put('/auth/change-password', data),
  getAdmins: () => api.get('/auth/admins'),
  addAdmin: (data) => api.post('/auth/admins', data),
  deleteAdmin: (id) => api.delete(`/auth/admins/${id}`),
  resetAdminPassword: (id, newPassword) => api.put(`/auth/admins/${id}/reset-password`, { newPassword }),
  updatePermissions: (id, permissions) => api.put(`/auth/admins/${id}/permissions`, { permissions }),
};

export const stampsAPI = {
  create: (stampData) => api.post('/stamps', stampData),
  getAll: (search = '', page = 1, limit = 10) => {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    params.append('page', page);
    params.append('limit', limit);
    return api.get(`/stamps?${params.toString()}`);
  },
  getById: (id) => api.get(`/stamps/${id}`),
  update: (id, stampData) => api.put(`/stamps/${id}`, stampData),
  delete: (id) => api.delete(`/stamps/${id}`),
  verify: (uid) => api.get(`/stamps/verify/${uid}`),
  bulkImport: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/stamps/bulk-import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export default api;
